// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction } from "@fluentui/react";

import type { AppKeytipProps } from "@1js/acui-keytip";
import { getDefaultKeytipProps } from "@1js/acui-keytip";

export const derivePreviewFlyoutKeytip = memoizeFunction(
  (keytipProps?: AppKeytipProps): AppKeytipProps => {
    return keytipProps ? getDefaultKeytipProps(keytipProps, 29) : undefined;
  }
);
